import 'core-js/fn/object/assign';
import 'fetch-polyfill'

import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/main/Main';

let data;
let content;

// dev
/*
$.getJSON('./data/list-data.json', function (res) {
  data = res;
})
.then(function () {
  $.getJSON('./data/content.json', function (res) {
    content = res;
  })
  .then(function () {
    // when all is ready: render App-Component
    ReactDOM.render(<App data={data} content={content}/>, document.getElementById('app'))
  });
});
*/

//prod
$.getJSON('http://interaktiv.derbund.ch/ext/2016/howtovote/data/list-data.json', function (res) {
  data = res;
})
.then(function () {
  $.getJSON('http://interaktiv.derbund.ch/ext/2016/howtovote/data/content.json', function (res) {
    content = res;
  })
  .then(function () {
    // when all is ready: render App-Component
    ReactDOM.render(<App data={data} content={content}/>, document.getElementById('app'))
  });
});



// WEBPACK FOOTER //
// ./src/index.js